import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import { routes } from 'src/app/app-routing.module';
import { FeatureFlagUsecase } from 'src/app/application/feature-flags/feature-flag-use-case.service';
import { SignOutUsecase } from 'src/app/auth/application/usecases/sign-out/sign-out.usecase';
import { FeatureFlagEnum } from 'src/app/domain/features-flags/enum/featureFlag.enum';
import { Auth } from 'src/app/domain/models/auth.model';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  constructor(
    private router: Router,
    private signOutUsecase: SignOutUsecase,
    private featureFlagService: FeatureFlagUsecase
  ) {}

  public sessionId: number = 0;

  private _legacyLogout!: boolean;

  /**
   * Subject to destroy the subscription.
   */
  private destroy$ = new Subject<void>();
  /**
   * variable to know if the feature flag is enabled
   */
  featureFlagShowOldLogin!: boolean;

  saveToken(token: string) {
    localStorage.setItem('lealToken', token);
  }

  getToken() {
    const token = localStorage.getItem('lealToken');
    return token;
  }

  removeToken() {
    localStorage.removeItem('lealToken');
  }

  saveUserData(userData: Auth): void {
    localStorage.setItem('lealUserData', JSON.stringify(userData));
  }

  getUserData(): Auth | any {
    return JSON.parse(localStorage.getItem('lealUserData') as string);
  }

  removeUserData(): void {
    localStorage.removeItem('lealUserData');
    localStorage.removeItem('filters');
  }

  removeRoutingOptions(): void {
    localStorage.removeItem('lealRoutesOptions');
  }

  logout(): void {
    this.getValueFeatureFlag();
    this._legacyLogout =
      this.featureFlagShowOldLogin || ENVIRONMENT.login.showOldLogin;

    const warningAlertKey = `lealAlert-${this.getUserData()?.uidCms}-80`;
    const warningAlertValue = localStorage.getItem(warningAlertKey);

    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();
    this.clearCacheServiceWorker();
    this.router.resetConfig(routes);



    this.signOutUsecase
      .execute()
      .pipe(take(1))
      .subscribe(() => {

        if (warningAlertValue) {
          localStorage.setItem(warningAlertKey, warningAlertValue);
        }

        if (this._legacyLogout) this.router.navigate(['/login']);
        else window.open(ENVIRONMENT.login.url, '_self', 'noopener');
      });
  }

  initSessionId(): void {
    this.sessionId = new Date().getTime();
  }

  getSessionId(): number {
    return this.sessionId;
  }

  clearCacheServiceWorker() {
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
      });
    }
  }

  clearCookies() {
    document.cookie.split(";").forEach((cookie) => {
      const [name] = cookie.split("=");
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });
  }

  /**
  * @description Retrieves the value of the feature flag `CREATEAUDIENCE` and sets the value of `featureFlagAudiencia`.
  */
  getValueFeatureFlag() {
    this.featureFlagService.getFeatureFlag(FeatureFlagEnum.GLOBAL_GLOBAL_SHOW_OLD_LOGIN)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: boolean) => {
        this.featureFlagShowOldLogin = res;
      });
  }
}
